module.exports = __webpack_public_path__ + "media/images/information-5a02352896c1940fd784dccf077d308b.svg";